// EditListingForm.jsx
// Form component for editing listing details

import React from 'react';
import { styles } from './styles';
import ImageManager from './ImageManager';
import { CATEGORY_OPTIONS } from '../../constants';

const EditListingForm = ({
  listing,
  updating,
  previews,
  onFieldChange,
  onRemoveImage,
  onNewImages,
  onSubmit
}) => {
  const handleInputChange = (field) => (e) => {
    onFieldChange(field, e.target.value);
  };

  return (
    <form onSubmit={onSubmit} style={styles.form}>
      {/* Basic Information Card */}
      <div style={styles.formCard}>
        <h2 style={styles.cardTitle}>Basic Information</h2>
        
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            Title
            <span style={styles.required}>*</span>
          </label>
          <input
            type="text"
            placeholder="e.g., Like-new IKEA Desk"
            value={listing.title}
            onChange={handleInputChange('title')}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>
            Description
            <span style={styles.required}>*</span>
          </label>
          <textarea
            placeholder="Describe your item's condition, features, and any details buyers should know..."
            value={listing.description}
            onChange={handleInputChange('description')}
            required
            style={styles.textarea}
            rows={5}
          />
        </div>
      </div>

      {/* Pricing & Category Card */}
      <div style={styles.formCard}>
        <h2 style={styles.cardTitle}>Pricing & Category</h2>
        
        <div style={styles.twoColumnGrid}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              Price
              <span style={styles.required}>*</span>
            </label>
            <div style={styles.priceInputWrapper}>
              <span style={styles.dollarSign}>$</span>
              <input
                type="number"
                placeholder="0.00"
                value={listing.price}
                onChange={handleInputChange('price')}
                required
                min="0"
                step="0.01"
                style={styles.priceInput}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>
              Category
              <span style={styles.required}>*</span>
            </label>
            <select
              value={listing.category}
              onChange={handleInputChange('category')}
              required
              style={styles.select}
            >
              <option value="">Select a category</option>
              {CATEGORY_OPTIONS.map((option, index) => 
                option.isHeader ? (
                  <option key={index} disabled style={{ 
                    fontWeight: 'bold', 
                    color: '#CE1126',
                    fontSize: '14px',
                    backgroundColor: '#f5f5f5'
                  }}>
                    {option.label}
                  </option>
                ) : (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
      </div>

      {/* Images Card */}
      <div style={styles.formCard}>
        <h2 style={styles.cardTitle}>Photos</h2>
        <ImageManager
          previews={previews}
          onRemoveImage={onRemoveImage}
          onNewImages={onNewImages}
        />
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        style={{
          ...styles.submitButton,
          ...(updating ? styles.submitButtonDisabled : {})
        }}
        disabled={updating}
      >
        {updating ? "Updating Listing..." : "Update Listing"}
      </button>
    </form>
  );
};

export default EditListingForm;